export default {
	required: v => !!v || 'Tämä tieto on pakollinen.',
	email: v => /.+@.+/.test(v) || 'Tarkista sähköpostiosoitteen muotoilu.',
}
